import { Mutation } from 'vuex';
import { IModuleState } from './types';

// 已保存的小组件列表
export const setWidgetList: Mutation<IModuleState> = (state, payload) => {
  state.widgetList.data = payload.data;
  state.widgetList.loading = !!payload.loading;
};

// 客户端使用统计
export const setClientUsageStats: Mutation<IModuleState> = (state, payload) => {
  state.clientUsageStats.data = payload.data;
  state.clientUsageStats.loading = !!payload.loading;
};

// 客户端使用明细列表
export const setClientUsageList: Mutation<IModuleState> = (state, payload) => {
  state.clientUsageList.data = payload.data;
  state.clientUsageList.loading = !!payload.loading;
};

// 客户端出错上报统计
export const setClientCrashStats: Mutation<IModuleState> = (state, payload) => {
  state.clientCrashStats.data = payload.data;
  state.clientCrashStats.loading = !!payload.loading;
};

// 客户端出错上报明细列表
export const setClientCrashList: Mutation<IModuleState> = (state, payload) => {
  state.clientCrashList.data = payload.data;
  state.clientCrashList.loading = !!payload.loading;
};

// 文件下载统计
export const setOssDownloadStats: Mutation<IModuleState> = (state, payload) => {
  state.ossDownloadStats.data = payload.data;
  state.ossDownloadStats.loading = !!payload.loading;
};

// 文件下载明细列表
export const setOssDownloadList: Mutation<IModuleState> = (state, payload) => {
  state.ossDownloadList.data = payload.data;
  state.ossDownloadList.loading = !!payload.loading;
};

// 用户异常登录统计
export const setLoginThreshStats: Mutation<IModuleState> = (state, payload) => {
  state.loginThreshStats.data = payload.data;
  state.loginThreshStats.loading = !!payload.loading;
};

// 用户异常登录统计明细列表
export const setLoginThreshList: Mutation<IModuleState> = (state, payload) => {
  state.loginThreshList.data = payload.data;
  state.loginThreshList.loading = !!payload.loading;
};

// 专案和样板间新增数量统计
export const setDpgIncrementStats: Mutation<IModuleState> = (state, payload) => {
  state.dpgIncrementStats.data = payload.data;
  state.dpgIncrementStats.loading = !!payload.loading;
};

// 专案和样板间新增数量明细列表
export const setDpgIncrementList: Mutation<IModuleState> = (state, payload) => {
  state.dpgIncrementList.data = payload.data;
  state.dpgIncrementList.loading = !!payload.loading;
};

// 首页小组件对应的编码字典
export const setWidgetOptions: Mutation<IModuleState> = (state, payload) => {
  state.widgetOptions.data = payload.data;
  state.widgetOptions.loading = !!payload.loading;
};

// 保存状态
export const setSaving: Mutation<IModuleState> = (state, payload) => {
  state.saving = payload;
};
